/* global swal angular */
import './style.less';

export default function($log, $state, $stateParams, Swal, ApiClass, ProfileClass) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  vm.loggedIn = ProfileClass.loggedIn;

  const profile_uid = (ProfileClass.profileComplete.profile || {}).profile_uid;

  vm.stateParams = $stateParams;

  vm.answerData = {
    radio: [],
    input: [],
    text_area: [],
    checkbox: []
  };

  vm.submit = answers => {
    vm.submitBtn = true;

    const id = vm.courseInfo.course_id;

    const review = {
      course_id: vm.courseInfo.course_id,
      form_id: vm.courseInfo.form_id,
      profile_uid,
      ...answers
    };

    return ApiClass.coursesIdTypePut({ id, type: 'reviews' }, { review })
      .then(() => {
        _toast('Evaluation has been submitted');
        vm.submitBtn = false;
        if (profile_uid) return $state.go('app.users.dashboard', { id: profile_uid });

        $state.go('app.register');
      })
      .catch(error => {
        vm.submitBtn = false;
        $log.error(error);
        throw error;
      });
  };

  function _toast(message) {
    Swal.toast(message, 'info');
  }

  function getLogo() {
    try {
      vm.courseInfo.logo = vm.courseInfo.sponsor ? vm.courseInfo.sponsor.logoUrl : false;
    } catch (error) {
      $log.error('Error loading sponsor image');
    }
  }

  function activate() {
    ApiClass.coursesIdGet({ id: $stateParams.id })
      .then(({ data: { course } }) => {
        const progress = course.progress;
        const form_id = course.form_id;
        if (vm.loggedIn && !progress) throw new Error('No Progress');
        if (!form_id) throw new Error('No Form');
        vm.courseInfo = course;
        getLogo();
        vm.formData = course.evaluationForm;
        vm.resultsQueried = true;
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/courseEvaluation/controller.js